import { BasePlugin } from '../base'
import mdcTopAppBar from './mdc-top-app-bar.vue'
import mdcTopAppBarAction from './mdc-top-app-bar-action.vue'

export { mdcTopAppBar, mdcTopAppBarAction }

export default BasePlugin({
  mdcTopAppBar,
  mdcTopAppBarAction
})
